import PropTypes from 'prop-types';
import { Box, Card, CardContent, Chip, Divider, Stack, Typography } from '@mui/material';

import {
  SERVICE_ORDER_STATUS_COLORS,
  SERVICE_ORDER_STEPS,
  serviceOrderStatusLabel,
} from '../../../utils/serviceOrderStatuses';
import StatusProgress from './StatusProgress';

const formatDate = (value) => (value ? new Date(value).toLocaleDateString('es-PE') : '—');

// Tarjeta de una orden de servicio tecnico en el panel del cliente / "Mis ordenes de servicio":
// en que paso va (pendiente, contacto, recibido, en proceso, entregado).
export default function CustomerServiceOrderCard({ order, compact }) {
  const statusName = order.status?.name;
  const activeIndex = SERVICE_ORDER_STEPS.findIndex((step) => step.key === statusName);

  return (
    <Card>
      <CardContent>
        <Stack direction="row" sx={{ justifyContent: 'space-between', alignItems: 'flex-start', mb: 1.5 }}>
          <Stack>
            <Typography variant="subtitle1">{order.service?.name || 'Servicio técnico'}</Typography>
            <Typography variant="caption" color="text.secondary">
              {order.service?.service_type?.name ? `${order.service.service_type.name} · ` : ''}Orden N.° {order.id}
              {order.is_urgent ? ' · Urgente' : ''}
            </Typography>
          </Stack>
          <Chip
            size="small"
            label={serviceOrderStatusLabel(statusName)}
            color={SERVICE_ORDER_STATUS_COLORS[statusName] || 'default'}
          />
        </Stack>

        <Box sx={{ mb: 1.5 }}>
          <StatusProgress steps={SERVICE_ORDER_STEPS} activeIndex={activeIndex} />
        </Box>

        {!compact && order.description && (
          <Typography variant="body2" sx={{ mb: 1.5 }}>
            {order.description}
          </Typography>
        )}

        <Divider sx={{ mb: 1 }} />

        <Stack direction="row" spacing={3}>
          <Typography variant="caption" color="text.secondary">
            Registrado: {formatDate(order.received_at)}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Entregado: {formatDate(order.finished_at)}
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
}

CustomerServiceOrderCard.propTypes = {
  order: PropTypes.object.isRequired,
  compact: PropTypes.bool,
};

CustomerServiceOrderCard.defaultProps = {
  compact: false,
};
